import * as React from 'react';
import { IAuthProps, TRight } from '../../services';

interface IProps {
  children: React.ReactNode;
  right: TRight;
}

class Gate extends React.Component<IAuthProps & IProps> {
  render() {
    let p = this.props;
    if(p.auth && p.auth.hasRight(p.right)) return p.children;
    return null;
  }
}

export { Gate }
